<template>
  <CustomUpdateDialog
    dialogTitle="جزئیات اطلاعیه"
    dialogId="notification-details-dialog"
    okOnly
    okTitle="بستن"
    @ok="closeNotificationDetailsDialog"
  >
    <BCol cols="12" v-if="notificationDetails">
      <div
        class="description-wrapper w-100"
        style="white-space: pre-line"
        v-html="notificationDetails.description"
      ></div>
    </BCol>
  </CustomUpdateDialog>
</template>

<script>
export default {
  async mounted() {
    const userData = await this.getUserByToken();
    localStorage.removeItem("userData");
    this.$nextTick(() => {
      localStorage.setItem("userData", JSON.stringify(userData));
    });
    window.dispatchEvent(new CustomEvent("unreadCount-localstorage-changed"));
  },
  props: {
    notificationDetails: {
      type: Object,
    },
  },
  watch: {
    notificationDetails: {
      handler(val) {
        if (val) {
          this.markNotificationAsRead();
        }
      },
    },
  },
  data() {
    return {
      markAsReadPayload: {
        userId: 0,
        notificationId: 0,
      },
    };
  },
  methods: {
    async markNotificationAsRead() {
      try {
        if (!this.notificationDetails.isRead) {
          this.markAsReadPayload.userId = this.userData.user.userId;
          this.markAsReadPayload.notificationId = this.notificationDetails.id;
          const _this = this;
          const markAsRead = new MarkAsRead(_this);
          markAsRead.setRequestParamDataObj(_this.markAsReadPayload);
          await markAsRead.fetch(async (res) => {
            if (res.isSuccess) {
              const userData = await this.getUserByToken();
              localStorage.removeItem("userData");
              this.$nextTick(() => {
                localStorage.setItem("userData", JSON.stringify(userData));
              });
              window.dispatchEvent(
                new CustomEvent("unreadCount-localstorage-changed")
              );
            }
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getUserByToken() {
      return new Promise(async (resolve, reject) => {
        try {
          let _this = this;
          let getUserByToken = new GetUserByToken(_this);
          await getUserByToken.fetch((res) => {
            let userDetails = {
              user: res.data,
            };

            userDetails["role"] = this.userData.user.role;
            userDetails["userRoleAccesses"] =
              this.userData.user.userRoleAccesses;
            userDetails["token"] = this.userData.token;
            userDetails["refreshToken"] = this.userData.refreshToken;
            userDetails["ability"] = this.userData.ability;
            resolve(userDetails);
          });
        } catch (error) {
          console.error(error);
          reject(error);
        }
      });
    },
    closeNotificationDetailsDialog() {
      this.$nextTick(() => {
        this.$bvModal.hide("notification-details-dialog");
      });
    },
  },
  computed: {
    userData() {
      if (getUserData) {
        return getUserData();
      }
    },
  },
  components: {
    CustomUpdateDialog,
    BCol,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import { BCol } from "bootstrap-vue";
import { MarkAsRead } from "@/libs/Api/Notifications";
import { getUserData } from "@/auth/utils";
import { GetUserByToken } from "@/libs/Api/Users";
</script>
<style>
.description-wrapper img {
  max-width: 100%;
}
.description-wrapper > * {
  text-align: justify !important;
  margin-bottom: 0 !important;
}
</style>
